import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-40c6a3f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "about-section",
    class: "about"
};
const _hoisted_2 = { class: "site-container about-grid" };
const _hoisted_3 = { class: "portrait-wrap" };
const _hoisted_4 = { class: "portrait-frame" };
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "experience-card" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "25+"),
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("años acompañando"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode("decisiones importantes")
    ])
], -1));
const _hoisted_7 = /*#__PURE__*/ _createStaticVNode("<div class=\"about-copy\" data-v-40c6a3f2><p class=\"section-kicker\" data-v-40c6a3f2>La escribana</p><h2 data-v-40c6a3f2>Profesional cuando hace falta. Cercana, siempre.</h2><p class=\"about-lead\" data-v-40c6a3f2> Soy Mary Iglesias, escribana pública. Mi trabajo no empieza en el documento: empieza escuchando qué necesitás resolver. </p><p data-v-40c6a3f2> Te acompaño personalmente en cada etapa, explicando las alternativas con claridad y cuidando cada detalle jurídico para que puedas avanzar con tranquilidad. </p><div class=\"about-values\" data-v-40c6a3f2><div data-v-40c6a3f2><span data-v-40c6a3f2>01</span><strong data-v-40c6a3f2>Escucha</strong></div><div data-v-40c6a3f2><span data-v-40c6a3f2>02</span><strong data-v-40c6a3f2>Claridad</strong></div><div data-v-40c6a3f2><span data-v-40c6a3f2>03</span><strong data-v-40c6a3f2>Seguimiento</strong></div></div><a href=\"tel:+59899943824\" data-v-40c6a3f2> Hablar directamente con Mary <svg viewBox=\"0 0 24 24\" fill=\"none\" aria-hidden=\"true\" data-v-40c6a3f2><path d=\"M5 12h14m-5-5 5 5-5 5\" stroke=\"currentColor\" stroke-width=\"1.7\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-40c6a3f2></path></svg></a></div>", 1);
export default /*#__PURE__*/ _defineComponent({
    __name: 'AboutSection',
    setup(__props) {
        const portrait = new URL('@/assets/notarial-picture.jpeg', import.meta.url).href;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                                src: _unref(portrait),
                                alt: "Mary Iglesias, escribana pública"
                            }, null, 8, _hoisted_5)
                        ]),
                        _hoisted_6
                    ]),
                    _hoisted_7
                ])
            ]));
        };
    }
});
